/**
 * Ensures the Widerruf app modal renders above footer sections.
 * The theme assigns stacked z-index values to footer sections, which traps
 * the app modal inside a low stacking context.
 */
(function () {
  const BODY_OPEN_CLASS = 'widerruf-modal-open';
  const PORTAL_ID = 'widerruf-modal-portal';

  function ensurePortal() {
    let portal = document.getElementById(PORTAL_ID);

    if (!portal) {
      portal = document.createElement('div');
      portal.id = PORTAL_ID;
      document.body.appendChild(portal);
    }

    return portal;
  }

  function portalizeWidget(widget) {
    if (!widget || widget.dataset.portaled === 'true') return;

    const backdrop = widget.querySelector('.widerruf-backdrop');
    const dialog = widget.querySelector('.widerruf-dialog');

    if (!backdrop || !dialog) return;

    ensurePortal().append(backdrop, dialog);
    widget.dataset.portaled = 'true';
  }

  function portalizeAll() {
    document.querySelectorAll('.widerruf-widget').forEach(portalizeWidget);
  }

  function syncBodyState() {
    document.body.classList.toggle(
      BODY_OPEN_CLASS,
      Boolean(document.querySelector('.widerruf-dialog.is-open'))
    );
  }

  function init() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.widerruf-trigger');
      if (!trigger) return;

      portalizeWidget(trigger.closest('.widerruf-widget'));
    }, true);

    const observer = new MutationObserver(() => {
      portalizeAll();
      syncBodyState();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    portalizeAll();
    syncBodyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
